import { appMethod as app } from '@utils/app';
import { convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './VipCardList.less';

export default class VipCardList extends OfficialPage {
  state = {
    topNavBarData: {
      title: '会员卡',
      isDefault: 0
    },
    vipList: []
  }

  constructor(props) {
    super(props);
    document.title = '会员卡';
  }

  componentWillMount() {
    this.getVIPCardList()
  }

  getVIPCardList = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetUserVIPCardList',
      data: {
        parent_app_id: app.getAppId(),
      },
      success: function (res) {
        that.setData({
          vipList: res.data
        })
      },
      complete: function () { }
    })
  }
  turnToVipCard = e => {
    let id = e.currentTarget.dataset.id
    let appid = e.currentTarget.dataset.appid
    let isPaidCard = e.currentTarget.dataset.ispaidcard
    app.turnToPage(
      '/eCommerce/pages/vipCard/vipCard?detail=' +
      id +
      '&franchisee=' +
      appid +
      '&is_paid_vip=' +
      isPaidCard
    )
  }

  render() {
    const { showGetUserInfo, topNavBarData, vipList } = this.state
    return (
      <div className="official-page vip-card-list">
        <TopNav title="会员卡"/>
        <div className="page">
          <div className="vip-banner">
            <img
              src="http://cdn.jisuapp.cn/static/webapp/images/franchisee/vip-banner.jpg"
              mode="aspectFill"
            />
          </div>
          <div className="vip-list">
            {vipList.map((item, index) => {
              return (
                <React.Fragment key={item.id}>
                  <div
                    className="vip-item"
                    style={convertLineStyleData(
                      'background: ' +
                      (item.background_type == 1
                        ? item.background
                        : 'url(' + item.background + ')') +
                      ';background-size:cover;background-position:center center;'
                    )}
                    data-appid={item.app_id}
                    data-id={item.id}
                    data-ispaidcard={item.is_paid_vip}
                    onClick={this.turnToVipCard}
                  >
                    <div className="vip-item-cover">
                      <img src={item.logo} mode="aspectFill" />
                    </div>
                    <div className="vip-item-info">
                      <div className="vip-item-title">
                        {item.app_name + ' ' + item.title}
                      </div>
                      {item.discount != 0 ? (
                        <div className="vip-item-rights">
                          {'可享 ' + item.discount + '折'}
                        </div>
                      ) : item.coupon_list && item.coupon_list != '' ? (
                        <div className="vip-item-rights">可享 赠送优惠券</div>
                      ) : item.integral != 0 ? (
                        <div className="vip-item-rights">
                          {'可享 赠送' + item.integral + '积分'}
                        </div>
                      ) : item.birthday_coupon_list &&
                        item.birthday_coupon_list != '' ? (
                                <div className="vip-item-rights">生日 赠送优惠券</div>
                              ) : (
                                item.is_free_postage &&
                                item.is_free_postage == 1 && (
                                  <div className="vip-item-rights">可享 包邮</div>
                                )
                              )}
                    </div>
                    <div className="vip-item-bottom">
                      {'有效日期: ' +
                        (item.expired_time == -1
                          ? '永久有效'
                          : item.expired_time)}
                    </div>
                  </div>
                </React.Fragment>
              )
            })}
          </div>
          {vipList.length == 0 && (
            <div className="no-receive-card">
              <div className="tip-area">
                <img
                  className="tip-img"
                  src="http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/no-vip.png"
                />
                <span className="tip-text-1">暂无可用会员卡</span>
                <span className="tip-text-2">获取方式，可留意店家消息</span>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/vip-card-list/VipCardList.jsx